"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  align-content: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FlexContainer = _styledComponents.default.section(_templateObject(), function (_ref) {
  var flexDirection = _ref.flexDirection;
  return flexDirection;
}, function (_ref2) {
  var flexWrap = _ref2.flexWrap;
  return flexWrap;
}, function (_ref3) {
  var justifyContent = _ref3.justifyContent;
  return justifyContent;
}, function (_ref4) {
  var alignItems = _ref4.alignItems;
  return alignItems;
}, function (_ref5) {
  var alignContent = _ref5.alignContent;
  return alignContent;
});

FlexContainer.displayName = 'FlexContainer';
FlexContainer.propTypes = {
  className: _propTypes.default.string,

  /** Establishes the main-axis, thus defining the direction flex items are placed in the flex container. */
  flexDirection: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /** By default, flex items will all try to fit onto one line. You can change that and allow the items to wrap as needed with this property. */
  flexWrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /** Defines the alignment along the main axis. */
  justifyContent: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']),

  /** Defines the default behavior for how flex items are laid out along the cross axis on the current line */
  alignItems: _propTypes.default.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline']),

  /** Aligns a flex container's lines within when there is extra space in the cross-axis,  has no effect when there is only one line of flex items. */
  alignContent: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'stretch'])
};
FlexContainer.defaultProps = {
  className: '',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  alignContent: 'flex-start'
};
var _default = FlexContainer;
exports.default = _default;